import { Entity, Key } from '@briebug/ngrx-auto-entity';

@Entity({
  modelName: 'Training',
  uriName: 'trainings',
})
export class Training {
  @Key id?: number;
  certification!: string;
  categoryId!: number;
  productInstallationTypeId!: number;
  experienceThreshold?: number;
  handsOnHours?: number;
  classroomHours?: number;
  handsOnTestRequired?: boolean;
  handsOnPassFail?: boolean;
  handsOnRetakesAllowed?: boolean;
  handsOnUnlimitedRetakes?: boolean;
  handsOnYearlyRetakes?: boolean;
  classroomTestRequired?: boolean;
  classroomPassFail?: boolean;
  classroomRetakesAllowed?: boolean;
  classroomUnlimitedRetakes?: boolean;
  classroomYearlyRetakes?: boolean;
  trainingAgeMonths?: number;
  continuingEducationCadence?: 'NA' | 'YEARLY' | 'BIANNUAL';
  trainingType?: 'TRAINING' | 'CERTIFICATION';
  dolApproved?: boolean;
  baseTtw?: number | null;
}
